import { createReducer } from 'helpers/reducers-helper';
import { useReducer } from 'react';
import merge from 'lodash/merge';
import createUseContext from 'constate';
import { repo } from 'index';
import { errorHandler } from 'helpers/error-handler';

export const TOGGLE_2FA_DIALOG = 'TOGGLE_2FA_DIALOG';
export const TOGGLE_DISABLE_2FA_DIALOG = 'TOGGLE_DISABLE_2FA_DIALOG';
export const RESPONSE_2FA_AUTH = 'RESPONSE_2FA_AUTH';
export const START_VALIDATE_2FA_AUTH = 'START_VALIDATE_2FA_AUTH';
export const CHANGE_TOTP = 'CHANGE_TOTP';
export const REQUEST_START = 'REQUEST_START';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const VALIDATE_TOTP_SUCCESSFUL = 'VALIDATE_TOTP_SUCCESSFUL';
export const DISABLE_2FA_SUCCESSFUL = 'DISABLE_2FA_SUCCESSFUL';

export const FETCH_F2A_SECRET_STEP = 'FETCH_F2A_SECRET_STEP';
export const VALIDATE_F2A_STEP = 'VALIDATE_F2A_STEP';
export const SETUP_2FA_SUCCESSFUL_STEP = 'SETUP_2FA_SUCCESSFUL_STEP';

const use2Fa = () => {
  const initState = {
    base64Image: null,
    step: FETCH_F2A_SECRET_STEP,
    show2FaDialog: false,
    showDisable2FaDialog: false,
    totp: '',
    loading: false,
    error: '',
    needUpdateUserInfo: false,
  };

  const toggle2FaDialog = state => {
    if (state.show2FaDialog) {
      // close dialog
      if (state.step === SETUP_2FA_SUCCESSFUL_STEP) {
        return merge({}, initState, { needUpdateUserInfo: true });
      } else {
        return initState;
      }
    } else {
      return merge({}, state, { show2FaDialog: true });
    }
  };
  const toggleDisable2FaDialog = state => {
    if (state.showDisable2FaDialog) {
      return initState;
    } else {
      return merge({}, state, { showDisable2FaDialog: true });
    }
  };
  const response2FaAuth = (state, payload) => merge({}, state, { base64Image: payload });
  const startValidate2FaAuth = state => merge({}, state, { step: VALIDATE_F2A_STEP });
  const changeTotp = (state, payload) => merge(state, { totp: payload });
  const requestStart = state => merge({}, state, { loading: true });
  const requestError = (state, payload) => merge({}, state, { loading: false, error: payload });
  const validateTotpSuccessful = state =>
    merge({}, state, {
      loading: false,
      step: SETUP_2FA_SUCCESSFUL_STEP,
    });
  const disable2FaSuccessful = state =>
    merge({}, state, {
      loading: false,
      needUpdateUserInfo: true,
      showDisable2FaDialog: false,
    });

  const reducer = createReducer(
    {
      [TOGGLE_2FA_DIALOG]: toggle2FaDialog,
      [TOGGLE_DISABLE_2FA_DIALOG]: toggleDisable2FaDialog,
      [RESPONSE_2FA_AUTH]: response2FaAuth,
      [START_VALIDATE_2FA_AUTH]: startValidate2FaAuth,
      [CHANGE_TOTP]: changeTotp,
      [REQUEST_START]: requestStart,
      [REQUEST_ERROR]: requestError,
      [VALIDATE_TOTP_SUCCESSFUL]: validateTotpSuccessful,
      [DISABLE_2FA_SUCCESSFUL]: disable2FaSuccessful,
    },
    initState
  );
  const [state, dispatch] = useReducer(reducer, initState);

  const fetchTwoFactorAuth = () => {
    repo
      .fetchTwoFactorAuth()
      .then(value => {
        dispatch({
          type: RESPONSE_2FA_AUTH,
          payload: value.imageBase64,
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  const validate2FaTotp = () => {
    dispatch({ type: REQUEST_START });
    repo
      .enableTwoFactorAuth(state.totp)
      .then(() => {
        dispatch({
          type: VALIDATE_TOTP_SUCCESSFUL,
        });
      })
      .catch(error => {
        dispatch({
          type: REQUEST_ERROR,
          payload: errorHandler(error),
        });
      });
  };

  const disable2FaAuth = () => {
    dispatch({ type: REQUEST_START });
    repo
      .disableTwoFactorAuth()
      .then(() => {
        dispatch({
          type: DISABLE_2FA_SUCCESSFUL,
        });
      })
      .catch(error => {
        dispatch({
          type: REQUEST_ERROR,
          payload: errorHandler(error),
        });
      });
  };

  return { state, dispatch, fetchTwoFactorAuth, validate2FaTotp, disable2FaAuth };
};

export const use2FaContext = createUseContext(use2Fa);
